module.exports = __webpack_public_path__ + "img/input-title.38b1314e.png";